<template>
  <div id="container">
    <div id="login_bg">
      <div class="Login_left">
        <div class="Login_left_img"></div>
        <p>Card Hobby Seller Center</p>
      </div>
      <div id="LoginBox" v-loading="disabled">
        <div class="login_logo">
          <a href="/" class="logo"></a>
          <h1>Sign up to Card Hobby</h1>
        </div>
        <el-form class="register_box" :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item class="login_form_item" prop="email">
            <el-input class="login_ipt" v-model="ruleForm.email" placeholder="Enter your email"></el-input>
          </el-form-item>
          <el-form-item class="login_form_item" prop="name">
            <el-input class="login_ipt" v-model="ruleForm.name" minlength='6' maxlength='20' placeholder="Nickname"></el-input>
          </el-form-item>
          <el-form-item class="login_form_item" prop="Location" style="margin-bottom: 24px;">
          <div class="countries">
            <img src="../../../static/images/countries.svg" alt="">
          </div>
          <el-select class="login_ipt" placeholder="Please select the countries" v-model="value" popper-class='location'>
            <el-option label="us" value="1">
              <span style="position: relative;">
                <img style="position: absolute;top: 0;" src="../../../static/images/countries.svg" alt="">
              </span>
              <span style="margin: 0 0 0 32px;">us</span>
            </el-option>
            <el-option label="uk" value="2">
              <span style="position: relative;">
                <img style="position: absolute;top: 0;" src="../../../static/images/countries.svg" alt="">
              </span>
              <span style="margin: 0 0 0 32px;">uk</span>
            </el-option>
            <el-option label="us" value="3">
              <span style="position: relative;">
                <img style="position: absolute;top: 0;" src="../../../static/images/countries.svg" alt="">
              </span>
              <span style="margin: 0 0 0 32px;">us</span>
            </el-option>
            <el-option label="uk" value="4">
              <span style="position: relative;">
                <img style="position: absolute;top: 0;" src="../../../static/images/countries.svg" alt="">
              </span>
              <span style="margin: 0 0 0 32px;">uk</span>
            </el-option>
            <el-option label="us" value="5">
              <span style="position: relative;">
                <img style="position: absolute;top: 0;" src="../../../static/images/countries.svg" alt="">
              </span>
              <span style="margin: 0 0 0 32px;">us</span>
            </el-option>
            <el-option label="uk" value="6">
              <span style="position: relative;">
                <img style="position: absolute;top: 0;" src="../../../static/images/countries.svg" alt="">
              </span>
              <span style="margin: 0 0 0 32px;">uk</span>
            </el-option>
          </el-select>

        </el-form-item>
          <div class="code_box">
            <el-form-item class="login_form_item" prop="code">
              <el-input class="login_ipt" v-model="ruleForm.code" minlength='6' maxlength='6' placeholder="Enter 6-digit code"></el-input>
            </el-form-item>
            <div class="code text_blue" v-if="isCode" @click="getCode('ruleForm')"><span>Sent code</span></div>
            <div class="code text_gray" v-if="!isCode"><span>Resend in {{ times }}s</span></div>
          </div>
          <el-form-item class="login_form_item" prop="password">
            <el-input class="login_ipt password_ipt" type="flagType" v-model="ruleForm.password" minlength='6' maxlength='20' show-password placeholder="Enter password" @input="search">
                <i slot="suffix" class="showing" :class="[flag == true?'show':'noshow']" v-show="ifshow" @click="getFlag()" />
            </el-input>
          </el-form-item>
          <div class="forgot">
            At least 8 characters, 1 uppercase letter, 1 number & 1 symbol
          </div>
          <el-button class="text_btn" type="primary" :disabled="disabled" @click="submitForm('ruleForm')">Sign up</el-button>
          <!-- <div class="account_box">
            Don't have an account yet? <router-link class="text_blue" :to="{path:'/register'}">Sign up now</router-link>
          </div> -->
          <!-- <div class="terms_checked">
            <el-checkbox  v-model="checkbox " :label="1">{{radioNumber}}</el-checkbox >
            <div>
              I have read and accpted the <span class="text_blue">Terms of Service</span> and <router-link class="text_blue" :to="{path:'/terms/privacy'}">
                Privacy Policy</router-link>
            </div>
          </div>
          <div class="account_box">
            Already a member?<router-link class="text_blue" :to="{path:'/login'}">Sign in</router-link>
          </div> -->
        </el-form>
      </div>
    </div>
    <!-- <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="480px" style="margin-top: 25vh;">
      <div class="dialog_box">
        <div class="" style="margin:16px 0 10px">
          To proceed, please agree to the
          <a href="#" class="dialog_a">Terms of Service and PrivacyPolicy</a>
          .
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="isChecked">Agree</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
export default {
  name: 'index',
  components: {},
  data() {
    var userValidate = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Wrong email or password.'));
      } else if (this.smsMsg) {
        callback(new Error(this.smsMsg));
      } else {
        callback();
      }
    };
    return {
      flagType: 'password',
      flag: false,
      dialogTitle: "",
      dialogVisible: false,
      smsMsg: '',
      disabled: false,
      // checked: false,
      radioNumber:'',
      checkbox :false,
      times: 60,
      isCode: true,
      value: 'us',
      ifshow: false,
      ruleForm: {
        email: '',
        name: "",
        code: '',
        password: '',
      },
      rules: {
        email: [
          { required: true, message: 'Invalid email. Please check and try again.', trigger: 'blur' },
          { type: 'email', message: 'Invalid email. Please check and try again.', trigger: 'blur' },
          { validator: userValidate }
        ],
        name: [
          { required: true, message: 'Nickname.', trigger: 'blur' },
          // { pattern: /^[^[\u4E00-\u9FA5]+$/, message: "不能有汉字", trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9_]{6,20}$/, message: 'At least 6 characters, 1 uppercase letter', trigger: 'blur' },
        ],
        code: [
          { required: true, message: 'Invalid code. Please check and try again.', trigger: 'blur' },
          { min: 6, max: 6, message: 'Invalid code. Please check and try again.', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '6-20 characters, 1 uppercase letter, 1 number', trigger: 'blur' },
          { pattern: /^(?=.*[A-Z])(?=.*[a-z])[a-zA-Z]{6,20}$/, message: 'At least 6 characters, 1 uppercase letter', trigger: 'blur' },
        ]
      }
    }
  },
  mounted() {
  },
  methods: {
    //是否显示查看密码的图标
    search(){
      if(this.ruleForm.password.length>0){
        this.ifshow = true
      }else{
        this.ifshow = false
      }
    },
    //密码切换状态
    getFlag(){
       this.flag = !this.flag
       this.flagType = this.flag ? 'text' : 'password'//text为显示密码；password为隐藏密码
     },
    // isChecked() {
    //   this.dialogVisible = false
    //   this.radio = 1
    // },
    // dialog() {
    //   this.dialogVisible = true;
    //   this.dialogTitle = "Notice"
    // },

    // 获取验证码
    getCode(formName) {
      let that = this;
      this.$refs[formName].validateField('email', (val) => {
        if (val == "") {
          that.CheckEmail = true;
          that.isCode = false;
          var data = { 'email': this.ruleForm.email, "type": 0 }
          console.log(data)
          that.CheckEmail = true;
          that.isCode = false;
          // 倒计时
          that.timer = setInterval(() => {
            that.times--;
            if (that.times === 0) {
              that.times = 60;
              that.isCode = true;
              clearInterval(that.timer)
            }
          }, 1000)
          var data = { 'UserApi': 'UserApi', 'email': this.ruleForm.email, "type": 1 }
          console.log(data);
          that.$post('SendEmail', data)//向邮箱发送验证码
            .then((res) => {
              console.log("axios-res:", res);
              if (res.Result) {
                that.$message({
                  showClose: true,
                  message: 'Send Email Successful',
                  type: "success",
                });
              } else {
                this.disabled = false;
                let Msg = 'Send Email Failed';
                that.$message.error(Msg);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      })
    },
    submitForm(formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var data = { 'email': this.ruleForm.email, 'password': this.ruleForm.password, 'nickName': this.ruleForm.name, 'code': this.ruleForm.code }
          if (this.radio == 0) {
            // this.dialog()
            // this.$alert('To proceed, please agree to the Terms of Service and PrivacyPolicy.', 'Notice', { showConfirmButton: false });
          } else {
            this.disabled = true;
          }
        }
      });
    }
  }
}
</script>

<style scoped>
@import "../../../static/css/login.css";
/deep/ .el-form-item__error {
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/shared/register.vue